module.exports = __webpack_public_path__ + "static/media/icn_paytm.2098cad2.svg";